<template>
  <div class="product-row-card" v-if="product&&product.id">
    <div v-for="item in showDatas" :key="item.code"  class="product-row-card__column">
     {{item.label}}：<span class="content">{{ item.showContent}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductRowCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    showDatas:{
      get() {
        let tmp=[]
        this.productConfig.forEach(pc => {
          if(!this.product[pc.code]) {
            return
          }
          tmp.push({label:pc.name,showContent:this.product[pc.code]})
        })
        return tmp
      }
    }
  },
  data () {
    return {
      productConfig: [
        {code: 'code', name: '品番号'},
        {code:'skuCode', name: 'SKU'},
        {code: 'name', name: '品名'},
        {code: 'nameZh', name: '中文品名'},
        {code: 'color', name: '颜色'},
        {code:'size', name: '规格'},
        {code: 'attr1', name: '幅宽'},
        {code: 'attr2', name: '克重'}
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.product-row-card {
  display: flex;
  flex-wrap: wrap;
  &__column {
    margin-right: 6px;
    .content{
      font-weight: bold;
    }
  }

  &__column:last-child {
    margin-right: 0;
  }

  &__column:first-child {
    margin-left: 0;
  }
}


</style>
